import { render, staticRenderFns } from "./WholeCalendarCard.vue?vue&type=template&id=877901d2&scoped=true"
import script from "./WholeCalendarCard.vue?vue&type=script&lang=js"
export * from "./WholeCalendarCard.vue?vue&type=script&lang=js"
import style0 from "./WholeCalendarCard.vue?vue&type=style&index=0&id=877901d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877901d2",
  null
  
)

export default component.exports